import { Drawer } from '@mui/material';
import React from 'react';

import Notifications from '../../../components/notifications';
import { useLayoutCalculations } from '../hooks/use-layout-calculations';

export type NotificationPanelDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Notification Panel Drawer Component
 * Contains the notification panel with responsive behavior
 */
const NotificationPanelDrawer = ({ isOpen, onClose }: NotificationPanelDrawerProps) => {
  const { isDesktop, getNotificationDrawerWidth } = useLayoutCalculations();

  return (
    <Drawer
      variant={isDesktop ? 'persistent' : 'temporary'}
      anchor="right"
      open={isOpen}
      onClose={isDesktop ? undefined : onClose} // Only allow close on mobile
      sx={{
        width: isDesktop ? getNotificationDrawerWidth() : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: getNotificationDrawerWidth(),
          maxWidth: isDesktop ? getNotificationDrawerWidth() : 400,
          boxSizing: 'border-box',
          backgroundColor: 'var(--sub-bg-color)',
          borderLeft: '1px solid',
          borderLeftColor: 'divider'
        }
      }}
      ModalProps={{
        keepMounted: true
      }}
    >
      <Notifications onClose={onClose} />
    </Drawer>
  );
};

export default NotificationPanelDrawer;
